import React from 'react';
import './LoadingIndicator.scss';
var LoadingIndicator = function (props) {
    return React.createElement("div", { className: "LoadingIndicator", style: props.delay ? { animationDelay: props.delay + '' } : undefined },
        React.createElement("span", null),
        React.createElement("span", null),
        React.createElement("span", null));
};
export default LoadingIndicator;
